module.exports = __webpack_public_path__ + "img/computer_speed.3232efc4.png";